import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDraggable]',
  exportAs: 'appDraggable'
})
export class DraggableDirective {
  @Input('appDraggableHandle') handleSelector?: string;

  private handle?: HTMLElement;
  private dragging = false;
  private startX = 0;
  private startY = 0;
  private baseX = 0;
  private baseY = 0;
  private hasDragged = false;

  constructor(private el: ElementRef<HTMLElement>) { }

  // Determine the handle element based on the selector or default to the host element
  private resolveHandle() {
    this.handle = this.handleSelector
      ? (this.el.nativeElement.querySelector(this.handleSelector) as HTMLElement | null) || undefined
      : this.el.nativeElement;
  }

  private getCurrentTranslate() {
    const style = getComputedStyle(this.el.nativeElement);
    const matrix = style.transform || '';
    if (matrix && matrix !== 'none') {
      const vals = matrix.match(/-?\d+(\.\d+)?/g)?.map(Number) || [0, 0, 0, 0, 0, 0];
      return { x: vals[4] || 0, y: vals[5] || 0 };
    }
    return { x: 0, y: 0 };
  }

  private applyTranslate(x: number, y: number) {
    const dlg = this.el.nativeElement;
    dlg.style.transform = `translate(${x}px, ${y}px)`;
    dlg.style.zIndex = '1055';
  }

  @HostListener('pointerdown', ['$event'])
  onPointerDown(ev: PointerEvent) {
    this.resolveHandle();
    if (!this.handle || !this.handle.contains(ev.target as Node)) return;

    (ev.target as Element).setPointerCapture?.(ev.pointerId);

    // Only reset baseX/baseY after first drag
    const current = this.getCurrentTranslate();
    this.baseX = current.x;
    this.baseY = current.y;
    this.startX = ev.clientX;
    this.startY = ev.clientY;

    this.dragging = true;
    ev.preventDefault();
  }

  @HostListener('document:pointermove', ['$event'])
  onPointerMove(ev: PointerEvent) {
    if (!this.dragging) return;

    this.hasDragged = true;
    const deltaX = ev.clientX - this.startX;
    const deltaY = ev.clientY - this.startY;

    this.applyTranslate(this.baseX + deltaX, this.baseY + deltaY);
  }

  @HostListener('document:pointerup')
  onPointerUp() {
    this.dragging = false;
  }

  // Call this when opening modal so it stays centered until drag
  public resetPosition() {
    this.hasDragged = false;
    this.el.nativeElement.style.transform = '';
    this.el.nativeElement.style.position = '';
    this.el.nativeElement.style.margin = 'auto';
    this.el.nativeElement.style.width = '';
    this.el.nativeElement.style.maxWidth = '';
  }
}
